var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2107_6599)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8244 0.704305C25.4917 -2.22522 36.4552 4.26445 39.3133 15.1951C42.1714 26.1291 35.84 37.3667 25.1759 40.2963C14.5086 43.2258 3.54507 36.7361 0.687 25.8055C-2.17107 14.8715 4.15705 3.63383 14.8244 0.704305Z",
    fill: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9023 10.5806C16.302 10.5806 17.4349 12.7827 17.4349 15.502C17.4349 18.2214 16.302 20.4235 14.9023 20.4235C13.5026 20.4235 12.3698 18.2214 12.3698 15.502C12.3698 12.7861 13.5026 10.5806 14.9023 10.5806ZM7.30139 26.8898C7.43811 24.2439 8.776 23.0661 11.1523 22.966L9.2122 24.9446C14.6451 32.1616 25.817 32.0048 30.625 24.9312L28.8444 23.1161C31.2207 23.2162 32.5553 24.3974 32.6953 27.04L31.4062 25.7287C26.0221 35.0945 14.6224 35.4281 8.39189 25.7787L7.30139 26.8898ZM25.0976 10.5806C26.4974 10.5806 27.6302 12.7827 27.6302 15.502C27.6302 18.2214 26.4941 20.4235 25.0976 20.4235C23.7011 20.4235 22.5651 18.2214 22.5651 15.502C22.5618 12.7861 23.6979 10.5806 25.0976 10.5806Z",
    fill: "#141518"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2107_6599"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 41,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.04706499c16158d5139dcce579f12b75.svg";
export { ForwardRef as ReactComponent };